import React, { useState, useEffect } from 'react';




// material
import { alpha, styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import {
  Card, Box, Grid, Typography,

  Modal,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Button,
  TextField,
  InputAdornment,
  FormHelperText
} from '@mui/material';

import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import { parseValidationErrorMessage } from '../../../utils/Utilities'


import { useAuth } from '../../customContextProviders/AuthContext';
import { DeviceEventRequestByServer } from '../../../network/Device';







// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.primary.darker,
  backgroundColor: "#FFFFFF"
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.primary.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0)} 0%, ${alpha(
    theme.palette.primary.dark,
    0.24
  )} 100%)`
}));


const useStyles = makeStyles({
  customDashCard: {
    background: "#FFFFFF",
    boxShadow: "10px 10px 19px 1px #EAEAFF",
    borderRadius: "20px",
    minHeight: "190px"
  },
});


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 300,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 4,
  borderRadius: 1
};

const changeLanguageSchema = Yup.object().shape({
  language: Yup.string()
    .required('Required'),


});






export default function DeviceLanguageChangeModal({ opneAssignedModal, handleClose, onAction, merchantData }) {


  const { audioCubeAppLevelSettings } = useAuth()
  const [languageVal, setLanguageVal] = useState('')


  const changeLanguageFormik = useFormik({
    initialValues: {
      language: '',
    },
    validationSchema: changeLanguageSchema,
    onSubmit: () => {

      DeviceEventRequestByServer(merchantData?.organizationId,
        merchantData?.id, merchantData?.device_id, "DEVICE_SET_LANGUAGE", new Date().getTime(), changeLanguageFormik?.values?.language)
        .then((res) => {
          handleClose()
          onAction('Device language change processed !')
        }).catch((err) => {
          onAction(parseValidationErrorMessage(err))
        })

    }
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = changeLanguageFormik;


 







  return (
    <Box>
      <Modal
        open={opneAssignedModal}
        onClose={handleClose}
        aria-labelledby="device-language-modal-title"
        aria-describedby="device-language-modal-description"
        data-testid='change-language-modal'
      >

        <FormikProvider value={changeLanguageFormik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Box sx={style}>
              <Typography sx={{ fontSize: 18, fontWeight: 900, mb: 3 }}>Change Language</Typography>

              {
                audioCubeAppLevelSettings?.language !== undefined && audioCubeAppLevelSettings?.language !== null ?
                  <FormControl fullWidth  >
                    <InputLabel id="device-language">Language</InputLabel>
                    <Select
                      labelId="device-language"
                      id="device-language-select"
                      label="Language"
                      {...getFieldProps('language')}
                      error={Boolean(touched.language && errors.language)}
                      helperText={touched.language && errors.language}>

                      {
                        Object.entries(audioCubeAppLevelSettings?.language)?.map(([key, value]) => (
                          <MenuItem value={key} sx={{ p: 1.5 }}>{value}</MenuItem>
                        ))
                      }

                    </Select>
                  </FormControl>
                  :
                  null
              }




              <Button data-testid='confirm-lang-change' variant="contained" type='submit' fullWidth size="large" sx={{ mt: 3 }} >Change</Button>


            </Box>
          </Form>
        </FormikProvider>

      </Modal>


    </Box>
  );
}
